'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userCreditCardsSelector = exports.lastOrdersSelector = undefined;

var _reselect = require('reselect');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastOrdersSelector = exports.lastOrdersSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.currentUser;
}, function (currentUser) {
  var orderCmpFn = function orderCmpFn(order1, order2) {
    return _lodash2.default.isEqual(order1.address, order2.address);
  };
  if (currentUser && currentUser.orders) {
    return _lodash2.default.uniqWith(currentUser.orders.filter(function (order) {
      return order.type === 'DELIVERY';
    }), orderCmpFn) || [];
  }
  return [];
});

var userCreditCardsSelector = exports.userCreditCardsSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.currentUser;
}, function (user) {
  if (!user) {
    return [];
  }
  if (!user.creditCards) {
    return [];
  }
  return user.creditCards;
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/user.js
// module id = 116
// module chunks = 0